import { Controller } from "@hotwired/stimulus";
import { leave, enter } from "@/el-transition";
import { useEmitter } from "@/emitter";

export default class extends Controller {
    static targets = ['counter']

    connect() {
        useEmitter(this)

        this.$on('loader:enter', () => {
            enter(this.element, 'loader')
        })

        this.$on('loader:leave', () => {
            leave(this.element, 'loader')
        })

        this.loadHandler = () => {
            window.scrollToForLoaderProcent(100, 1, async () => {
                await leave(this.element, 'loader')
                window.scrollToForLoaderProcent(-1, 1)
            })
        }

        addEventListener('turbo:load', this.loadHandler)

        this.fetchHandler = async () => {
            window.scrollToForLoaderProcent(90, 100, false, true)
            await enter(this.element, 'loader')
        }

        addEventListener('turbo:before-visit', this.fetchHandler)
    }

    disconnect() {
        removeEventListener('turbo:load', this.loadHandler)
        removeEventListener('turbo:before-visit', this.fetchHandler)
        this.$clear()
    }
}
